export const WOOSMAP_API_KEY = "woos-9f340ad6-422c-3940-b6e4-a01e0d215e4d";
